import { useSelector } from "react-redux";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";
import { useEffect, useState } from "react";

export default function InspectionResult({ result, setShowModal, panelState, setPanelState, machine }) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const inspectionStatusSettings = useSelector(
    (s) => s.app_settings.inspection_status
  );
  const [style, setStyle] = useState({
    color: getInspectionResutlColor(
      result?.inspection_result,
      resultSymbolSetting,
      result?.not_inspect
    ),
    background: getInspectionResutlBackground(
      result?.inspection_result,
      resultSymbolSetting,
      result?.not_inspect,
      true
    ),
  });

  useEffect(() => {
    if (
      panelState?.day === result?.inspection_day &&
      panelState?.dailyInspection &&
      panelState?.machine === machine
    ) {
      setStyle((s) => ({
        ...s,
        background: "#feec88",
      }));
    } else {
      setStyle((s) => ({
        ...s,
        background: getInspectionResutlBackground(
          result?.inspection_result,
          resultSymbolSetting,
          result?.not_inspect,
          true
        ),
      }));
    }
  }, [panelState, result?.day])

  const handleShowInspection = () => {
    if (result?.inspection_result === -1 && result.not_inspect) {
      return;
    }
    setPanelState((state) => ({
      ...state,
      day: result?.inspection_day,
      dailyJudgment: false,
      monthlyJudgment: false,
      dailyInspection: true,
      inspection: result?.id,
      workflow: result?.workflow,
      machine: machine,
    }));
    setShowModal(true);
  }
  return result?.inspection_result === undefined ? (
    <div className={`${
        inspectionStatusSettings.daily_approval_status ? "w-1/2" : "w-full"
      } bg-white`}></div>
  ) : (
    <div
      style={style}
      className={`${
        inspectionStatusSettings.daily_approval_status ? "w-1/2" : "w-full"
      } text-center flex items-center justify-center bg-white ${
        result?.not_inspect ? "" : " cursor-pointer hover:!bg-[#feec88]"
      }`}
      onClick={() => handleShowInspection()}
    >
      <span>
        {getInspectionResutlSymbol(
          result?.inspection_result,
          resultSymbolSetting,
          result?.not_inspect
        )}
      </span>
    </div>
  );
}
